export default {
  appTitle: 'Arcaea - 超感覚リズムゲーム',
  appDescription: '超感覚リズムゲーム - &quot;失われた世界で描かれる 『光』と『対立』の物語が 今、はじまる・・・！&quot;',
  hrefLang: 'ja',
  switchTitle: 'Arcaea for ニンテンドースイッチ',
  confirm: '決定',
  cancel: 'キャンセル',
  inMaintenance: '現在メンテナンス中です。<br/>お手数ですが、数時間後に再度アクセスし直して下さい。',
  hours: '{hours}時間',
  minutes: '{minutes}分',
  seconds: '{seconds}秒',
  error: 'エラー',
  generalError: 'エラーが発生しました。<br/>お手数ですがページを更新いただき、もう一度お試しください。',
  potential: 'ポテンシャル',
  daysLeft: '残り{day}日',
  subscribe: '加入する',
  subscribeCancel: '月額プランを解約',
  loading: 'ロード中…',
  search: 'Search...',
  redirecting: '数秒後にリダイレクトします。',
  return: '戻る',
  returnToArcaeaOnline: 'Arcaea Onlineへ戻る',
  ok: 'OK',
  save: '保存する',
  calculating: '現在計上中…',
  clearStatsDisclaimer: '端末のオンライン状況によっては、Arcaea Onlineとお手元の端末でスコア表示などが異なる場合があります。',
  changelog: {
    title: `Arcaea Onlineの新機能`,
    list: `
    <div>全員が利用できる機能</div>
    <ul class="changelog-list">
      <li>楽曲のクリア統計をプロフィールページに追加</li>
      <li>プロフィールページとTOPプレイの記録で情景が変更可能に</li>
      <li>一部ヨーロッパ地域のメモリー購入手段にPayPalを追加（今後他地域でも対応予定）</li>
    </ul>
    <div>月額プラン加入時に利用できる新機能</div>
    <ul class="changelog-list">
      <li>スコアデータページでの楽曲検索</li>
      <li>スコアデータに追加の新規ソート項目『スコア順(MAX差分)』</li>
      <li>ポテンシャルページにて、対象楽曲のPure/Far/Lostの内訳表示</li>
      <li>スコアデータ、ポテンシャルページでスコアの記録日表示</li>
      <li>ポテンシャル推移のグラフに3年、5年の切り替え表示</li>
    </ul>`
  },
  menu: {
    songRanking: '楽曲ランキング',
    story: 'ストーリー',
    goods: 'グッズ',
    login: 'ログイン',
    account: 'My Account'
  },
  footer: {
    copyright: '© 2023 lowiro',
    contact: '問い合わせ',
    terms: '利用規約',
    derivativeWorks: '二次創作ガイドライン',
    privacyPolicy: 'プライバシーポリシー',
    streamingGuidelines: '配信ガイドライン'
  },
  homepage: {
    artist: '作曲',
    artwork: 'イラスト',
    songDescription: 'Arcaeaに収録されている楽曲をランダムにピックアップ。'
  },
  account: {
    login: 'ログイン',
    logout: 'ログアウト',
    errorLogin: 'ログインできませんでした。入力情報を改めてご確認ください。',
    username: 'ユーザー名',
    checking: '確認中',
    changeUsername: 'ユーザー名を変更',
    nameUnavailable: 'そのユーザー名は使用できません。別のユーザー名をお使いください。',
    nameInvalid: 'ユーザー名は3文字以上15文字以下の英数字にしてください',
    email: 'メールアドレス',
    changeEmail: 'アドレスを変更する',
    errorEmailUnavailable: 'こちらのメールアドレスはすでに使用されています。<br/>別のメールアドレスをご使用ください。',
    memories: 'メモリー',
    passwordReset: 'パスワードリセット',
    enterEmail: '登録したメールアドレスを入力してください',
    submit: '送信',
    usernameEmailID: 'ユーザー名/ID、メールアドレス',
    forgotPassword: 'パスワードを紛失した',
    errorInvalidEmail: '有効なメールアドレスを入力してください',
    errorUnknownEmail: '入力したメールアドレスは、登録されていません。',
    requestForgotSuccess: 'パスワードの再設定のため、ご指定のメールアドレスをご確認ください。',
    newPassword: '新しいパスワードを入力してください',
    newPasswordConfirm: '新しいパスワードの確認',
    passwordResetInput: '新しいパスワード',
    passwordResetConfirm: '新しいパスワードの確認',
    passwordResetSuccess: 'パスワードが変更されました',
    errorMismatchPassword: '入力されたパスワードが一致しません',
    errorInvalidPassword: 'パスワードは8文字以上にしてください',
    errorInvalidResetToken: 'パスワード再発行用URLの有効期限が切れています。もう一度やり直してください。',
    password: 'パスワード',
    loginCaps: 'ログイン',
    creditCard: 'カード / その他',
    purchaseMemories: 'メモリーの購入',
    nameChangeWarn: 'ユーザー名の変更に伴い、<span class="bold highlight-color">{amount}メモリー</span> を消費します。<br/>よろしいですか？',
    payUsing: 'お支払い方法',
    proccessingPayment: '処理中…',
    purchase: '購入する',
    purchaseFailed: '購入失敗',
    purchaseFailedDescription: '購入手続きに失敗しました。<br/>お手数ですが、再度お試しください。',
    purchaseComplete: '購入完了',
    justAdded: '{amount}メモリーが追加されました。',
    thankYou: 'ご利用ありがとうございました。',
    Account: 'アカウント',
    backToAccount: 'アカウントへ戻る',
    currentMemories: '所持メモリー',
    usernameCost: 'ユーザー名の変更には<span class="bold">{amount}メモリー</span>がかかります。',
    change: '変更する',
    cancel: 'キャンセル',
    newName: '新しいユーザー名',
    newNameConfirm: '変更後のユーザーネーム:',
    newEmailConfirm: '変更後のメールアドレス:',
    newEmail: '新しいメールアドレス',
    emailChangeWarn: 'メールアドレスを以下のものに変更してもよろしいですか？ <b>{email}</b>',
    checkInbox: 'まだ未完了です。入力されたアドレスに認証リンクを含むメールを送りましたので、ご確認下さい。',
    verifyingEmail: '認証中',
    verifyEmailSuccess: 'メールアドレスが無事に変更されました。',
    errorVerifyEmail: 'メールアドレスの変更に失敗しました。お手数ですが、最初からもう一度やり直して下さい。',
    agree: '同意する',
    version: 'バージョン{version}',
    deleteUser: 'アカウント削除のご確認',
    verifyDeleteUserSuccess: '無事、あなたのArcaeaアカウントは削除されました。<br/>楽しんで頂き、ありがとうございました。',
    errorVerifyDeleteUser: 'アカウントの削除に失敗しました。お手数ですが再度の試行をお願いします。',
    verifyingDeleteUser: '認証中',
    selectYourRegion: 'ご利用の地域を選んで下さい',
    ensureSelectRegion: 'メモリーのWEB購入には、支払い方法の地域と、<br/>ご利用の地域が合致している必要があります。',
    selectRegionConfirm: 'ご利用する地域',
    digitalContents: 'デジタルコンテンツ',
    manageDigitalOST: 'コンテンツの管理/DL',
    owned: '所有OST {amount}種',
    errorInvalidUserCode: '9桁の数字を入れてください',
    errorAddFriend: 'フレンド追加時、エラーが発生しました',
  },
  arcaeaOnline: {
    subscribedUntil: '月額プランの有効期限: {date}',
    benefit1: 'スコアデータへのアクセス',
    benefit2: 'フレンドの合計スコアボードへのアクセス',
    benefit3: 'ポテンシャルの詳細情報',
  },
  scoreData: {
    playsThisYear: '年間プレイ回数',
    leaderboards: 'ランキング',
    obtained: `スコア更新日時`,
    obtainedDate: `スコア更新日時: {date}`
  },
  leaderboard: {
    totalScoreRanking: 'Total Score Ranking',
    world: '全世界',
    friend: 'フレンド内',
    top50: 'Top 50',
    myRank: 'ランク',
    lastUpdated: '最終更新日: {date}',
  },
  ptt: {
    topRatedRecentPlays: '直近のTOPプレイ',
    top30Plays: 'TOP30曲',
    noPlays: 'プレイ履歴なし',
    '1W': '週次',
    '1M': '月次',
    '1Y': '年次',
  },
  friend: {
    addFriend: 'フレンドを追加',
    pleaseEnterPlayerId: 'フレンド申請するプレイヤーIDを入力して下さい',
    sendFriendRequest: 'フレンドを追加',
    friendCount: 'フレンド人数 {friendCount}/{maxCount}',
    removeFriendTitle: 'フレンドを解除する',
    removeFriend: 'フレンドから外す',
    areYouSureRemove: '本当に<b>{name}</b>さんをフレンドから外しますか？ ',
    friendList: 'フレンドリスト',
    maxIncreaseInGame: '登録できるフレンド上限は、Arcaeaアプリから増やすことができます。',
    errorFriendYourself: 'あなた自身をフレンドにすることはできません(´；ω；｀)',
    errorAlreadyFriend: 'このユーザーは既にあなたのフレンドになっています',
    errorDoesNotExist: 'そのユーザーが存在しません',
    errorFriendLimit: 'フレンド登録数が上限に達しました。',
  },
  subscription: {
    subscription: '月額プランについて',
    subscribe: '加入する',
    autoRenew: '月額プランを自動更新する',
    renewalInfo: '自動更新を有効にすると、メモリーが不足している場合を除き、加入から30日後に月額プランが自動継続されます。',
    benefitHeader: '加入者特典',
    spendMemories: '<b>200</b>メモリーで月額プラン(30日分)に加入しますか？',
    confirmPurchase: '確認',
    notEnoughMemories: 'メモリーが不足しています',
    memoriesRequired: '{amount}メモリーが必要です',
    redirectToMemory: 'メモリーを追加するために、メモリー購入のページにジャンプしますか？',
    confirmCancel: '本当に月額プランを解約しますか？',
    cancelDisclaimer: '月額プランを解約しても、プランの残り期間中は月額プランのサービスをご利用いただけます。',
    keepSubscription: '月額プランを継続',
    cancelSubscription: '月額プランを解約',
    paymentComplete: '加入登録完了',
    paymentCompleteMessage: 'Arcaea Onlineの月額プランにご加入ありがとうございます。引き続きArcaeaをお楽しみください。',
    required: '月額プラン会員のみ',
    requiredText: 'この機能のご利用には、月額プランの加入が必要です。',
    goToSubscribe: '月額プランに加入',
    yourSubscription: '月額プラン加入状況',
    renewMessage: '月額プランは {arcaeaOnlineExpiredDate} に自動更新されます。',
    reactivate: '月額プランに再加入',
    success: '加入登録完了',
    successMessage: 'Arcaea Onlineの月額プランにご加入ありがとうございます。引き続きArcaeaをお楽しみください。',
    cancelled: '月額プラン解約済み',
    cancelledMessage: '月額プランが解約されました。購読時限定の機能は、 {arcaeaOnlineExpiredDate} まで利用可能です。'
  },
  clearType: {
    clear: 'CLEAR',
    fr: 'FULL RECALL',
    pm: 'PURE MEMORY',
  },
  sort: {
    by: 'ソート分類',
    name: '名前順',
    level: 'レベル順',
    date: '日付順',
    score: 'スコア順',
    title: '曲名順',
    scoreBelowMax: 'スコア順 (MAX差分)'
  },
  partner: {
    level: 'レベル',
    currentPartner: '現在のパートナー',
    selected: '選択中'
  },
  characterType: {
    0: 'BALANCE',
    1: 'SUPPORT',
    2: 'CHALLENGE',
    3: 'CREATOR',
  },
  profile: {
    scenerySelectTitle: '情景設定',
    sceneryUnlockInGame: '情景はArcaeaアプリのWorld Modeから解禁することができます'
  },
  worldUnlock: {
    locked: 'World Modeにて解禁可能<br/>{index}にて',
    beginning: '旅立ち',
    lockedchap1: 'チャプター1',
    lockedchap2: 'チャプター2',
    lockedchap3: 'チャプター3',
    lockedchap4: 'チャプター4',
    lockedchap5: 'チャプター5',
    lockedchap6: 'チャプター6',
    lockedchap7: 'チャプター7',
    lockedbeyond: 'Lost Chapter: Beyond',
    unlockedchap1 : '失われた世界',
    unlockedchap2 : '世界の外れ',
    unlockedchap3 : '収束の螺旋塔',
    unlockedchap4 : '眠れる残響',
    unlockedchap5 : '果てない齟齬',
    unlockedchap6 : '忘らるる造形',
    unlockedchap7 : '追憶の地平',
    unlockedbeyond: 'Lost Chapter: Beyond',
  },
  sidebar: {
    profile: 'プロフィール',
    friends: 'フレンド',
    partners: 'パートナー',
    leaderboards: 'スコアボード',
    scoreData: 'スコアデータ',
    potential: 'ポテンシャル',
    memoriesAndSubscription: 'メモリー / 月額プラン',
    accountAndSettings: 'アカウント管理 / 設定',
  },
  goods: {
    originalSoundtracks: 'オリジナルサウンドトラック',
    diverseDirect: 'DIVERSE DIRECTで購入',
    tanoc: 'TANO*C STOREで購入',
    amazon: 'Amazon.co.jpで購入',
    lineHeader: 'Arcaea公式LINEスタンプ',
    lineText1: 'シエラ先生描き下ろしスタンプが登場！ <br/>お気に入りのキャラで可愛く会話を彩ろう！',
    lineButton: 'LINE Storeへ!'
  },
  digitalContents: {
    ostHeader: 'サウンドトラック一覧',
    generateDownloadLink: 'DLリンクを生成する',
    redeemOST: 'OSTシリアルコード入力',
    redeemOSTDescription: 'お手持ちのCD版オリジナルサウンドトラック付属のシリアルコードを入力してください。シリアルコードの入力は、<b>Arcaea</b>アプリ ＞『<b>Network</b>』内の『<b>コードを利用</b>』から行えます。',
    downloadRemaining: 'ダウンロード残り回数 {amount}回',
    downloadsRemaining: 'ダウンロード残り回数 {amount}回',
    notOwned: '未購入'
  },
  songRanking: {
    freeMusic: 'フリープレイ楽曲',
    paidMusic: 'プレミアム楽曲',
    title: '曲名',
    artist: 'アーティスト名',
    new: 'New!!'
  },
  verify: {
    verifyAccount: 'アカウントの認証',
    enterEmail: '登録したメールアドレスを入力してください',
    verify: '認証する',
    verifySuccess: 'アカウント認証に成功しました。',
    errorInvalidEmail: '無効なアドレスです。お手数ですがもう一度、ご確認をお願いします。',
    errorInvalidToken: 'アカウント登録を完了できません。ご利用のURLは無効か、有効期限が過ぎたものです。再度メールをご確認頂くか、再度アカウントを登録し直して下さい。',
    errorExpiredToken: 'URLの有効期限を過ぎています。お手数ですが初めからアカウント登録をやりなおしてください。',
    errorCaptchaFailed: 'CAPTCHA認証に失敗しました。再度お試し下さい。',
  },
  purchase: {
    sorryNotSupported: '申し訳有りません。ご利用の地域ではArcaea公式サイトからのメモリー購入はご利用出来ません。',
    memoryWithBonus: '{amount} + ボーナス ({bonusAmount})',
    priceCurrencyFront: '{currency}{amount}',
    priceCurrencyBack: '{amount}{currency}'
  },
  contact: {
    header: 'ご質問、サポート、PRなど'
  },
  story: {
    slide1: {
      text: `ふたりの少女は、旅をする。<br/>
伏せられた過去と音で満ちた、 この砕けた世界で――。<br/>
<br/>
この廃墟ばかりの世界でそれぞれ 少女たちは孤独に目を覚ます。<br/>
なにも思い出せない空っぽな自分に、 同じく空虚なこの世界。<br/>
<br/>
そして、鮮烈な記憶を孕む、数多の硝片、<br/>
Arcaea（アーケア）と出会うのだった。<br/>`,
    },
    slide2: {
      text: `まるで体感される人物を選ぶかのように、硝片はそれぞれの少女に引き寄せられる。<br/>
そしてまた、少女たちもそれぞれに記憶を追体験していくことになる。<br/>
<br/>
<i>"――硝片がその身に映すのは、少女を取り巻く白い世界とは異なる情景。見えるのは海に街々、火と、そして光。両手を上げれば遠ざかる硝片を見て、彼女は楽しげに笑っている。"</i><br/>
<br/>
<i>"――硝片の中にはどうやら、一瞬だけ何か別の物を見ることができた。それはまるで、電車の窓から見える景色のよう。<br/>
ある硝片では雨、ある硝片では日差しを。そしてある硝片では、死を見た。思わず渋面になって、彼女は硝片から目を背ける。"</i><br/>
      `
    },
    slide3: {
      text: `少女がふたり、ひび割れた世界で、過去を解き明かしていく。<br/>
<br/>
一人は光の、もう一人は闘争の過去を。<br/>
<br/>
このArcaeaの世界を探索することで、どのように少女たちは変わっていくのだろう？<br/>
<br/>
<i>"こんなに美しく、シンプルな世界は、ただ美しくあればいいのだ。あとは、いらない。"</i><br/>
<br/>
<i>"硝片の映す場所にはどこにも…ほとんど光が見えない。見える小さな火花も瞬時に消える。"</i><br/>
<br/>
そして少女たちは、旅路の果てに至ったとき、はたして何者になっているのか――？
`,
    }
  },
  links: {
    facebook: 'https://www.facebook.com/arcaeagame',
    twitter: 'https://twitter.com/arcaea_jp',
    line: 'https://line.me/R/ti/p/%40sfc8511n',
    lineSticker: 'https://store.line.me/stickershop/product/7686361/ja',
  },

  text: {
    termsOfService: `<p><b>最終更新日:</b> 2023年1月17日</p>

<p>lowiro limited（以下「当社」といいます。）が定める本規約は、当社が提供するゲーム『Arcaea』や、関連するウェブサイト上のサービスなど（以下、「本サービス」といいます。）の利用に関する事項について定めるものです。</p>
<p>『Arcaea』内のユーザー登録や、オンラインサービスの利用、関連ウェブサイトの利用等、本サービスの利用を以て、お客様が本規約の内容にすべて同意したものとみなします。本規約にご同意いただけない場合、本サービスをご利用いただけません。</p>
<p>本サービスは13歳以上の方のみご利用いただけます。</p>
<p>本規約には、いつでも以下のリンク(<a href="https://arcaea.lowiro.com/terms_of_service">https://arcaea.lowiro.com/terms_of_service</a>)よりアクセスすることができます。
当社は、本規約およびプライバシーポリシーの一部を変更、修正、追記、または削除する権利を有します。なお、その内容の変更は、同リンクに更新版を掲載することにより行われます。
本規約の変更後にお客様が本サービスをご利用いただいた場合、変更後の本規約とプライバシーポリシーの最新版に同意したものとします。
</p>

<b>1. 定義</b>
本規約の内容を明確にするため、予め特定の単語の意味合いを定義します。
    ● アカウント: ゲーム内のユーザーのアカウントのこと
    ● メモリー: 法定通貨で購入可能な、Arcaeaのゲーム内通貨のこと
    ● サービス: Arcaeaアプリ（全プラットフォーム含む）と、そのオンラインサービス、およびその公式ウェブサイトを総称したもの
    ● 本規約: この利用規約の内容すべてのこと
    ● 私たち: 弊社lowiro limitedのこと    ● あなた: プレイヤー・ユーザーの皆さまの総称

<b>2. アカウント作成</b>
    <b>2.1</b>   メモリーの購入、フレンドの追加、そしてスコアボードなど、『Arcaea』オンラインサービスのご利用には、アカウントを登録する必要があります。
    <b>2.2</b>   アカウント登録とその利用には、インターネットに接続している必要があります。
    <b>2.3</b>   お客様が登録出来るアカウントは、ひとりにつきひとつに限られます。
    <b>2.4</b>   アカウント登録、または当社サービスを利用することで、あなたは自身の年齢が最低でも13歳であり、また本規約全文を理解の上、同意することを表明したものとします。

<b>3. ライセンスと使用制限</b>
    <b>3.1</b>   本規約の遵守を条件として、当社はお客様に、非営利の娯楽目的でのみ、非独占的かつ他者への譲渡が不可能な、本サービスを利用する権利を許諾します。お客様は、他の目的で本サービスを利用することはできません。
    <b>3.2</b>   お客様は、本サービスの利用にあたり、以下の禁止事項を行ってはならないものとします。
        1. 何らかの手段によるアプリの不正な改ざん行為
        2. 自身のアカウントを、第三者に共有、譲渡、貸与する等の一切の行為
        3. 同一人物による複数アカウントの同時所有行為
        4. アプリのリバースエンジニアリング、逆コンパイル、逆アセンブル行為
        5. データマイニングなどによる、アプリ内のデータやコードを収集する行為
        6. データスクレイピングなどによる、本サービスに関する情報や、お客様自身を含む本サービスの利用ユーザーに関する情報を収集する行為
        7. 本サービスを第三者に頒布、譲渡、再許諾、リース、貸与する等の一切の行為
        8. 本サービスの機能を、任意の方法で不特定多数のユーザーが利用できるようにする行為
        9. 他者への詐欺または侵害を目的として、本サービスを利用する行為
        10. 当社、本サービスに対して虚偽の情報を提供する行為、または当社、本サービスに関する虚偽の情報を流布する行為
        11. 本サービスまたは本サービスを提供するサーバーもしくはネットワークに不正にアクセスする行為
        12. 本サービスのネットワークに接続するにあたり、端末等の環境が要件または規制に違反する行為
        13. 本サービスを構成する要素等を、制御するために設計された技術的手段を回避する行為
    <b>3.3</b>   当社は、本規約に基づいてお客様に明示的に付与されていない、本サービスに関するすべての権利を保有します。

<b>4. 二次創作についてのポリシー</b>
二次創作にまつわる当社のポリシーに関しては、こちら(<a href="https://arcaea.lowiro.com/derivative_policy">https://arcaea.lowiro.com/derivative_policy</a>)にガイドラインを用意しましたので、参照していただければ幸いです。なお、本規約への同意は、該当のガイドラインをお読みいただいた上で同意するものとします。

<b>5. アプリ内購入と請求</b>
    <b>5.1</b>   当社のサービスには、ゲーム内通貨の一種であるメモリーが含まれています。メモリーは各国の法定通貨で購入することができ、ゲーム内で追加のコンテンツを購入するために使用されます。
    <b>5.2</b>   メモリーは、当社が提供する本サービス内においてのみ使用することができるものとし、当社、第三者問わず、金品や、他のサービス等に変換、交換することはできません。
    <b>5.3</b>   当社は、お客様に対して一切の責任を負うことなく、メモリーを管理、規制、変更、または削除する権利を保有します。
    <b>5.4</b>   該当する法律で義務付けられている場合を除き、現金によるメモリーの払い戻しは行いません。 メモリーを購入することでお客様が、選択した手段による決済能力があるものとします。
    <b>5.5</b>   メモリーで購入したゲーム内コンテンツの現金による払い戻しは行いません。Google Playなどの弊社が管轄しない外部手段により、使用後のメモリーの払い戻しを行った場合、当該メモリーで購入したコンテンツのアカウントからの削除や、アカウントの停止を行う場合があります。
    <b>5.6</b>   メモリーの購入がアカウントに反映されなかった場合は、<a href="mailto:contact@lowiro.com">contact@lowiro.com</a> 宛にご連絡ください。
    <b>5.7</b>   当社がお客様の責めに帰すべき事由により、本規約に基づきお客様のアカウントを停止した際には、お客様の同意を得ることなく、保有するメモリーを無効とし、当社はいかなる損害にも一切責任を負わないものとします。

<b>6. アカウントの停止</b>
当社は、お客様が以下の各号のいずれかに該当する場合、当社はお客様のアカウントを停止する権利を保有します。
    <b>6.1</b>   お客様のアカウントが第3条2節のいずれかに該当する場合
    <b>6.2</b>   お客様による著作権法を含むあらゆる法律に対する侵害があると当社が判断した場合
    <b>6.3</b>   お客様が当社、本サービス、またはそのスタッフに対する脅威または嫌がらせに関与したと当社が判断した場合
    <b>6.4</b>   その他、フェアプレー精神に反する行為など、本サービスのお客様として不適当と当社が判断した場合

<b>7. プライバシー</b>
ユーザーからの個人情報の取り扱いについては、<a href="https://arcaea.lowiro.com/privacy_policy">プライバシーポリシー</a>をご参照ください。

<b>8. 免責事項</b>
    <b>8.1</b>   ゲームプレイ中または本サービスの使用中に発生した、物理的、デジタル的、または金銭的な問題等、いかなる問題に対して、当社は一切の責任を負わないものとします。
    <b>8.2</b>   第5条4節で定めた通り、すべてのメモリーは返金不可であり、それによる損害がお客様に生じた場合でも、当社は一切の責任を負わないものとします。

<b>9. Arcaeaのアップデート</b>
    <b>9.1</b>   当社はお客様への事前の告知なく、いつでも本サービスの全部または一部を変更することができます。これらの変更には、ゲームプレイの仕組み、ビジュアルデザイン、キャラクター（「パートナー」）の利用可能性、および楽曲の利用可能性が含まれますが、これらに限らないものとします。
    <b>9.2</b>   当社は、いつでもいかなる理由においても本規約を変更する権利を保有します。本規約の変更によるお客様の損害について、お客様自身が責任を負うものとします。

<b>10. 準拠法</b>
本規約は、イギリス連合王国および北アイルランドの法律に準拠します。本サービスの利用により当社とお客様の間に紛争が生じた場合、イギリスで解決されます。

<b>11. 連絡先情報</b>
バグまたは支払いの失敗を報告する場合は、問題の明確な説明、ゲーム内のユーザー名、ID、および可能であれば、問題を示すスクリーンショットを添えて<a href="mailto:contact@lowiro.com">contact@lowiro.com</a>にお問い合わせください。広告やPRなどその他のお問い合わせも、<a href="mailto:contact@lowiro.com">contact@lowiro.com</a>にお問い合わせください。`,

    derivativePolicy: `<p><b>最終更新日:</b> 2023年12月21日</p>
<p>lowiroでは、ファンがArcaeaの世界とそのキャラクターを使って、いわゆる二次創作の形で独自の創作をすることを歓迎しています。Arcaeaで二次創作するにあたって、こちらがそのガイドラインとなりますので、許可できるものと許可できないものなどの質問に関して、参照していただければと思います。</p>
<p>なお、Arcaeaの利用規約の同意は、本ガイドラインへの同意も兼ねるものとなります。ご了承ください。</p>
<b>1. 使用できるものとできないもの</b>

<p>基本的な方針として、媒体がデジタルか物理かを問わず、lowiroがリリースまたは著作権を保有する素材や資材の流用は不可となります。ここでの該当する対象は主に、Arcaeaアプリ内のものはもちろん、オンラインサービス上のもの、ツイッターやDiscordなどの公式チャンネル上のもの、そして物理とデジタルの両媒体の公式の商品群すべてを指しますが、この限りではありません。</p>
<p>本ガイドラインはArcaeaのメインストーリーとサイドストーリーにおけるキャラクター、設定、ストーリー、その他の内容を二次創作目的で利用する許可を認めるものです。とはいえ、一部のその他のキャラクターや設定（例えば特定のイベントのものなど）や、コラボなどでのその他のコンテンツは弊社以外の著作権保有者の許可を必要とするものがございます。本ガイドラインはその部分の利用を認めるものではないため、そちらに関しましては使用前に、お客様自身で該当の著作権保有者に確認をとって頂く必要があることもございます。</p>
<p><u>アートワーク・イラスト</u>: 自身の作品での使用を意図して、キャラクターやイベント画像を含むゲームの素材を複製または使用することはできません。これには物理とデジタルの両媒体が含まれます（例：公式CDのデザインやアートワークなど）。ただし前述の、素材を複写したりしていない場合に限り、ゲームに基づいた独自のイラストなどを制作することは可とします。</p>
<p><u>楽曲</u>: 派生作品を含むあらゆる目的で、Arcaeaアプリ内または公式サウンドトラックに含まれる音楽・効果音を使用することはできません。これには音楽ゲームでの二次創作譜面・レベル差分なども含みます。</p>
<p><u>ストーリー</u>: 二次創作での使用を意図する形で、Arcaeaのストーリーの原文を複製することは不可とします。しかしながら、ストーリー自体を自身の創作の基盤として、漫画や小説に使うことは可とします。</p><br/><ul><li><u>翻訳について</u>: 現状提供されていない言語での翻訳を自身で行った上で使いたい、という方がいらっしゃいましたら、その具体的な使い方などを含め、サポート用メールアドレス（<a href="mailto:contact@lowiro.com">contact@lowiro.com</a>）までご一報ください。</li></ul>
<p><u>ロゴ</u>: Arcaeaロゴ、lowiroロゴ、もしくはそれに類似する画像を使用することは、二次創作も含め、どのような目的であっても不可とします。</p>
<b>2. 利用用途</b>

<p>lowiroは、Arcaeaに関するいかなる要素や素材を、以下の二次創作作品に使用、または何らかの形で流用することを明確に禁じます。</p><ul><li>ゲーム（物理・デジタル問わず）</li><li>ソフトウェア・アプリケーション</li><li>法人主体によるありとあらゆる二次創作作品</li></ul>
<p>その他の形式での二次創作作品については、物理・デジタルを問わず、本ガイドラインに抵触・違反しない限りは許可の対象です（ファンアート/小説/漫画 etc...）</p>
<p>また、許可の対象に該当する二次創作作品は、200部未満である限り、個人による制作・販売の範疇として許可します。</p>
<p>ただし、個人で200部以上（同一作品の再発行・再出版・再制作含む）を制作・販売する場合は、弊社lowiroへの直接の許可を取ることを必須とします。本件に関するお問い合わせは、弊社の「<a target="_blank" href="https://lowiro.com/ja-jp/contact.html">お問い合わせフォーム</a>」よりご送信・ご申請ください。</p>
<b>3. 免責事項</b>
<p>本ガイドラインは著作権で保護されたコンテンツをパブリックドメインとして公開するものでもなければ、著作権で保護されたコンテンツの、著作権の有効範囲を変更するものでもございません。Arcaeaのあらゆる二次創作的使用を不許可とする権利や、その許可自体を取り下げる権限をlowiroは留保しています。また、事前告知なく本ガイドラインを編集する権限も同じく留保しているものとします。ですので、どうか二次創作を手掛ける前に、本ガイドラインの最新版をご一読ください。</p>`,

    privacyPolicy: `<p><b>最新更新:</b> 2019年8月26日</p>
<p>Arcaeaはフリーミアムアプリとオンラインのウェブサイトサービスとしてlowiro limitedによって設立されました。以下ではアプリ、Webサイト、およびすべてのWebサービスをまとめて「サービス」と呼びます。サービスは無料でlowiro limitedによって提供され、全てそのままでの使用を意図しています。</p>
<p>このプライバシーポリシー（以下、ポリシー）は、お客様の個人情報の収集、使用、および開示に関する当社の方針について、当社サービスの訪問者およびユーザーにむけた周知を目的としています。私達のサービスを利用することは、私たちがどのような情報を収集し、またそれをどのように使用するかを含む、当プライバシーポリシーに対して同意するものと同義とします。</p>
<p>私達が収集するあなたに関する情報は、前述サービスを提供し改善するためにのみ使用されます。このポリシーに記載されている場合を除き、私たちはあなたの情報を第三者と使用、または共有しません。</p>

<b>情報の収集と利用</b>
<p>よりよいゲーム体験のため、サービスの利用中に個人情報の提供を要求することがあります。この情報にはあなたのEメールアドレスが含まれますが、要求されるものはこれに限りません。私たちはこれらの情報を保持し、またこのポリシーに記載される用途でのみ使用します。</p>
<p>あなたが特別に私たちに要請しない限り、提供していただいたEメールアドレスにマーケティングやその他を問わず、いかなるEメールをも送ることはありません。</p>
<p>アプリは個人の識別用途で使用される、情報の収集をするサードパーティのサービスを使用しています。以下は本アプリにて使用されている、各サードパーティサービスのプロバイダが公開するプライバシーポリシーへのリンクです。</p>
• <a target="_blank" href="https://www.google.com/policies/privacy/">Google Play Services</a>
• <a target="_blank" href="https://firebase.google.com/policies/analytics/">Firebase Analytics</a>
• <a target="_blank" href="https://fabric.io/privacy">Fabric</a>
• <a target="_blank" href="http://try.crashlytics.com/terms/privacy-policy.pdf">Crashlytics</a>

<b>ログデータ</b>
<p>当社サービスを利用する際、万が一エラーが発生した場合、当社は「ログデータ」と呼ぶお客様のデバイスからデータおよび情報を収集します（上記のサードパーティ製品を通じて）。このログデータには、端末のIPアドレス、端末のモデル、OSのバージョン、アプリの現在設定、アプリをプレイしていた日時、およびその他統計データなどの情報が含まれます。</p>

<b>Cookie</b>
<p>Cookieは少量のデータを含むファイルです。これらは一般に、ユーザーの匿名性を保護しながらユーザーを識別するために使用されます。あなたが訪問したウェブサイトはあなたのブラウザにCookieを送り、そしてこれらのCookieはその後あなたの端末の内部メモリに保存されます。</p>
<p>Arcaeaはあなたがサービスにログインすることを可能にするためにCookieを使用します。また、Cookieを使用して情報を収集し、サービスを向上させるサードパーティのコードやライブラリを使用することもあります。あなたはこれらのCookieの使用を受け入れるか拒否するか、そしてCookieがあなたのデバイスにいつ送られているかを知る権利を持っています。当社からのCookieを受け入れないことを選択した場合、本サービスの一部を使用できなくなる可能性があります。</p>

<b>サービスプロバイダー</b>
<p>当社は、以下の理由により、第三者の会社および個人を雇用することがあります。</p>
• 当社のサービスを促進するため。
• 当社に代わって本サービスを提供するため。
• サービスに関連するサービスを実行するため。または
• 当社のサービスがどのように使用されているかを分析するのを支援するため。

<p>これらのサードパーティは、当社のサービスを利用する人の個人情報にアクセスすることとなります。これは割り当てられたタスクを実行するためであり、そして彼らは、この情報を他の目的で開示または使用しないことを義務付けられています。</p>

<b>セキュリティ</b>
<p>個人データは最新のソフトウェアを使用して安全に保存され、サービス開発に関連した場合にアクセスを必要とする人のみがアクセスすることが出来ます。防災や復旧のための解決策も整っています。</p>
<p>しかし、インターネット上でのデータ転送や電子ストレージの手法に100％の安全性はありません。そのため、私たちのサービスを利用することで、あなたは自身の責任で私たちにこの情報を送ることに同意します。自身の個人情報が侵害されていると思う場合には、このポリシーの末尾にあるEメールアドレスにご連絡ください。</p>

<b>保持と消去</b>
<p>本サービスが利用可能である限り、個人データは保持されます。あなたが自身のアカウントを復旧し、将来いつでも本サービスに戻ることができるように、我々はこれに務めます。</p>
<p>あなたは私たちのシステムから自身の個人データの消去を要求することができます。これを行うには、登録アドレスを使用して電子メールで確認する必要があります。このプロセスは一度実行すると元に戻すことができず、また実行後はサービスの利用ができなくなります。</p>

<b>他のサイトへのリンク</b>
<p>本サービスには他のサイトへのリンクが含まれている場合があります。サードパーティのリンクをクリックすると、そのサイトに移動します。これらの外部サイトは当社によって運営されていないことに注意してください。したがって、これらのWebサイトのプライバシーポリシーを確認することを強くお勧めします。当社は、いかなるサードパーティのサイトまたはサービスのコンテンツ、プライバシーポリシー、または慣行についても管理せず、その責任を負いません。</p>

<b>子供のプライバシー</b>
<p>個人を特定できる情報を13歳未満のお子様から故意に収集することはありません。13歳未満のお子様から個人情報が提供されていることが判明した場合には、ただちにサーバーから削除するものとします。あなたが親または保護者であり、自身の子供が本サービスへと個人情報を提供したと判明した場合は、こちらで必要措置を講じることができるよう、本ポリシーの末尾にあるEメールアドレス宛にご一報下さい。</p>

<b>このプライバシーポリシーの変更</b>
<p>当社はプライバシーポリシーを随時更新することがあります。 したがって、このページを定期的に見直し変更点を把握することをお勧めします。 このページにて新規のプライバシーポリシーを掲載することで、変更をお知らせします。 これらポリシーにおける変更事項は、本ページにて掲載された直後より有効となります。</p>

<b>お問い合わせ</b>
<p>当社のプライバシーポリシーについてご質問・ご提案などがありましたら、お気軽に<a href="mailto:contact@lowiro.com>">contact@lowiro.com</a>までご連絡ください。</p>`,

    streamingGuidelines: `<p><b>最終更新日:</b> 2021年7月9日</p>

<p>Arcaeaを元にしたコンテンツ制作を、lowiroは応援・歓迎しております。今日までのArcaeaの成功は、他でもないファンの方々や、様々なコンテンツの作者さまのご協力あってのものです。今回関心をもっていただけたことにも、誠に感謝しております。</p>
<p>この度、YoutubeやTwitchなど、ストリーミングや動画制作におけるファンコミュニティへの円滑な寄与を確かにするため、ガイドラインをご用意いたしました。以下の内容をご一読の上、理解と遵守を宜しくお願い致します。</p>
<b>1. ガイドライン概要</b>
<ul><li>弊社は、プレイヤーのリアクションや感想、レビュー、チュートリアル、実況などの内容を含む、動画の制作や配信などを許可します。とはいえ、実況などはなるべくゲーム本体や、現在ゲームプレイに関連した内容であることを奨励します。</li><li>自作サイトを含む、どのサイトでも配信・動画投稿先として許可するものとします。</li><li>ファン制作コンテンツなど、その他のlowiroが公式に発表していない内容をlowiro公式と宣伝することはできません。</li><li>ストーリーやゲーム体験に関わる、いわゆる『ネタバレ』に関してはくれぐれもご留意をお願いします。プレイヤーの多くはネタバレを望みません。そのため、何らかのネタバレを含む場合は動画タイトルなどにネタバレを含むことをご明記ください。<br/>（とはいえ、その判断はあくまで各クリエイター様の良心に一任する形となります）</li><li>公式に告知されていない、公開されていないコンテンツの暴露、リークを含むコンテンツは厳禁とします。</li><li>実際のプレイ映像を含まない形で、ゲームデータ・素材を動画や他の形式で配布することは厳禁とします。映像やその他コンテンツでは、実際のプレイ映像をそのまま使用し、動画と音声を別の形で使うことはご遠慮下さい。配信や動画において、弊社コンテンツはゲームとして遊ばれているもののみ、使用を許可するものとします。</li><li>同様に、作成されるコンテンツはオリジナリティのあるもので有るべきだと弊社は考えます。よって、弊社の公式トレーラーやプレビュー動画の複製投稿などは、すべて禁止とします。</li><li>また、Arcaeaにおける他社さまのコラボレーションによるコンテンツ（『コラボパック』など）は、本ガイドラインでの許可の範囲外とするものとし、配信をする際は権利を保有する企業などの許可を別に取得するようお願いします。</li><li>弊社としては基本的に、メインストーリー・サイドストーリーパックほぼすべての曲を配信・動画投稿に含めることを歓迎しておりますが、例外としていくつかの曲がございます。ですが、今回ガイドラインという形でなるべく弊社としての方針を共有したい一方で、その厳密な許諾曲リストを公開することは、諸事情により難しいことをどうかご理解ください。そのため、lowiroが権利を持っていないであろう楽曲を配信・動画投稿に盛り込むかどうかは遺憾ながら、クリエイターさま各位の判断に一任する形となります。ご了承下さい。</li><li>関連して、前述の弊社が権利を持たない楽曲における、Content ID関連のトラブルに関しては弊社は責任を取ることができません。その点も踏まえて、配信に乗せる楽曲の判断を宜しくお願い致します。</li><li>楽曲の権利や配信の可否などの確認は、配信者、動画投稿者さまにおける責務と存じます。弊社として公開できる最善はここまでの内容となりますが、それを踏まえた上で、特定の楽曲においては上記以上の制限が生じることをどうかご了承下さい。</li></ul><b>2. 商業向けガイドライン</b>
<ul><li>無許可でのArcaeaと、そのコンテンツの商業利用はすべて厳禁とします。</li><li>とはいえ、動画自体が無料かつ、個人の範囲外で収益化をしない限り、個人におけるパートナープログラムや、配信サイトにおける広告経由の収益化、そして以下に列挙するいわゆる『投げ銭』はその例外となります。許容される投げ銭機能一覧：Superchat（Youtube）Bits（Twitch）tipping（Facebook）</li><li>企業や法人など、個人としてではない事業を代表して、またはその一員として収益化を希望する場合は、『<a href="mailto:contact@lowiro.com">contact@lowiro.com</a>』まで、要旨をまとめてご連絡下さい。</li></ul><b>3. 原則不許可とするもの</b>
<ul><li>Arcaeaに関連する動画コンテンツとして、不適切な内容を含むものは許可しません。具体的には年齢制限が考慮されるものや、違法の内容を含むもの、過度な偏見・差別を含むもの（人種差別、性差別、誹謗中傷など）のほか、不快な、または害意のあるコンテンツのことを指します。該当するコンテンツの削除を要請する権限を弊社は保持するものとします。</li><li>また、Arcaeaに関連する動画として、リークや事前漏洩などの内容も厳禁とし、こちらも同様に削除要請の対象となります。</li></ul><b>4. その他ルールなど</b>
<ul><li>>本ポリシー・ガイドラインはあくまでもlowiroとArcaeaに関するコンテンツのみに適用されるものです。その他、他社製コンテンツなどを配信・動画に含める場合は、該当するコンテンツを管理する企業の、動画・配信に関する規約やガイドラインをご確認するようお願いいたします。</li><li>上記ルールやガイドラインに沿わない配信・動画があった場合、弊社は該当コンテンツの削除要請など、なんらかの形で対応します。また、弊社は事前告知なく本ガイドラインを編集する権限も保持しております。お手数ではありますが、Arcaeaに関連するコンテンツを作成するたびに可能な限り内容をご確認頂くよう、宜しくお願いします。</li><li>また、本ガイドラインはすべてを網羅するものではないため、ここに含まれない不快なコンテンツも削除する権限を保有します。</li><li>二次創作における詳細なガイドラインにつきましては、こちらのリンク先をご参照下さい。<a href="https://arcaea.lowiro.com/derivative_policy">https://arcaea.lowiro.com/derivative_policy</a></li></ul>`
  },
  countries: [
    { "id": 352, "name": "アイスランド", "a2": "is" },
    { "id": 372, "name": "アイルランド", "a2": "ie" },
    { "id": 31, "name": "アゼルバイジャン", "a2": "az" },
    { "id": 4, "name": "アフガニスタン", "a2": "af" },
    { "id": 840, "name": "アメリカ合衆国", "a2": "us" },
    { "id": 850, "name": "アメリカ領ヴァージン諸島", "a2": "vi" },
    { "id": 16, "name": "アメリカ領サモア", "a2": "as" },
    { "id": 784, "name": "アラブ首長国連邦", "a2": "ae" },
    { "id": 12, "name": "アルジェリア", "a2": "dz" },
    { "id": 32, "name": "アルゼンチン", "a2": "ar" },
    { "id": 533, "name": "アルバ", "a2": "aw" },
    { "id": 8, "name": "アルバニア", "a2": "al" },
    { "id": 51, "name": "アルメニア", "a2": "am" },
    { "id": 660, "name": "アンギラ", "a2": "ai" },
    { "id": 24, "name": "アンゴラ", "a2": "ao" },
    { "id": 28, "name": "アンティグア・バーブーダ", "a2": "ag" },
    { "id": 20, "name": "アンドラ", "a2": "ad" },
    { "id": 887, "name": "イエメン", "a2": "ye" },
    { "id": 826, "name": "イギリス", "a2": "gb" },
    { "id": 86, "name": "イギリス領インド洋地域", "a2": "io" },
    { "id": 92, "name": "イギリス領ヴァージン諸島", "a2": "vg" },
    { "id": 376, "name": "イスラエル", "a2": "il" },
    { "id": 380, "name": "イタリア", "a2": "it" },
    { "id": 368, "name": "イラク", "a2": "iq" },
    { "id": 364, "name": "イラン・イスラム共和国", "a2": "ir" },
    { "id": 356, "name": "インド", "a2": "in" },
    { "id": 360, "name": "インドネシア", "a2": "id" },
    { "id": 876, "name": "ウォリス・フツナ", "a2": "wf" },
    { "id": 800, "name": "ウガンダ", "a2": "ug" },
    { "id": 804, "name": "ウクライナ", "a2": "ua" },
    { "id": 860, "name": "ウズベキスタン", "a2": "uz" },
    { "id": 858, "name": "ウルグアイ", "a2": "uy" },
    { "id": 218, "name": "エクアドル", "a2": "ec" },
    { "id": 818, "name": "エジプト", "a2": "eg" },
    { "id": 233, "name": "エストニア", "a2": "ee" },
    { "id": 748, "name": "エスワティニ", "a2": "sz" },
    { "id": 231, "name": "エチオピア", "a2": "et" },
    { "id": 232, "name": "エリトリア", "a2": "er" },
    { "id": 222, "name": "エルサルバドル", "a2": "sv" },
    { "id": 36, "name": "オーストラリア", "a2": "au" },
    { "id": 40, "name": "オーストリア", "a2": "at" },
    { "id": 248, "name": "オーランド諸島", "a2": "ax" },
    { "id": 512, "name": "オマーン", "a2": "om" },
    { "id": 528, "name": "オランダ", "a2": "nl" },
    { "id": 288, "name": "ガーナ", "a2": "gh" },
    { "id": 132, "name": "カーボベルデ", "a2": "cv" },
    { "id": 831, "name": "ガーンジー", "a2": "gg" },
    { "id": 328, "name": "ガイアナ", "a2": "gy" },
    { "id": 398, "name": "カザフスタン", "a2": "kz" },
    { "id": 634, "name": "カタール", "a2": "qa" },
    { "id": 581, "name": "合衆国領有小離島", "a2": "um" },
    { "id": 124, "name": "カナダ", "a2": "ca" },
    { "id": 266, "name": "ガボン", "a2": "ga" },
    { "id": 120, "name": "カメルーン", "a2": "cm" },
    { "id": 270, "name": "ガンビア", "a2": "gm" },
    { "id": 116, "name": "カンボジア", "a2": "kh" },
    { "id": 807, "name": "北マケドニア", "a2": "mk" },
    { "id": 580, "name": "北マリアナ諸島", "a2": "mp" },
    { "id": 324, "name": "ギニア", "a2": "gn" },
    { "id": 624, "name": "ギニアビサウ", "a2": "gw" },
    { "id": 196, "name": "キプロス", "a2": "cy" },
    { "id": 192, "name": "キューバ", "a2": "cu" },
    { "id": 531, "name": "キュラソー", "a2": "cw" },
    { "id": 300, "name": "ギリシャ", "a2": "gr" },
    { "id": 296, "name": "キリバス", "a2": "ki" },
    { "id": 417, "name": "キルギス", "a2": "kg" },
    { "id": 320, "name": "グアテマラ", "a2": "gt" },
    { "id": 312, "name": "グアドループ", "a2": "gp" },
    { "id": 316, "name": "グアム", "a2": "gu" },
    { "id": 414, "name": "クウェート", "a2": "kw" },
    { "id": 184, "name": "クック諸島", "a2": "ck" },
    { "id": 304, "name": "グリーンランド", "a2": "gl" },
    { "id": 162, "name": "クリスマス島", "a2": "cx" },
    { "id": 308, "name": "グレナダ", "a2": "gd" },
    { "id": 191, "name": "クロアチア", "a2": "hr" },
    { "id": 136, "name": "ケイマン諸島", "a2": "ky" },
    { "id": 404, "name": "ケニア", "a2": "ke" },
    { "id": 384, "name": "コートジボワール", "a2": "ci" },
    { "id": 166, "name": "ココス（キーリング）諸島", "a2": "cc" },
    { "id": 188, "name": "コスタリカ", "a2": "cr" },
    { "id": 174, "name": "コモロ", "a2": "km" },
    { "id": 170, "name": "コロンビア", "a2": "co" },
    { "id": 178, "name": "コンゴ共和国", "a2": "cg" },
    { "id": 180, "name": "コンゴ民主共和国", "a2": "cd" },
    { "id": 682, "name": "サウジアラビア", "a2": "sa" },
    { "id": 239, "name": "サウスジョージア・サウスサンドウィッチ諸島", "a2": "gs" },
    { "id": 882, "name": "サモア", "a2": "ws" },
    { "id": 678, "name": "サントメ・プリンシペ", "a2": "st" },
    { "id": 652, "name": "サン・バルテルミー", "a2": "bl" },
    { "id": 894, "name": "ザンビア", "a2": "zm" },
    { "id": 666, "name": "サンピエール島・ミクロン島", "a2": "pm" },
    { "id": 674, "name": "サンマリノ", "a2": "sm" },
    { "id": 663, "name": "サン・マルタン（フランス領）", "a2": "mf" },
    { "id": 694, "name": "シエラレオネ", "a2": "sl" },
    { "id": 262, "name": "ジブチ", "a2": "dj" },
    { "id": 292, "name": "ジブラルタル", "a2": "gi" },
    { "id": 832, "name": "ジャージー", "a2": "je" },
    { "id": 388, "name": "ジャマイカ", "a2": "jm" },
    { "id": 268, "name": "ジョージア", "a2": "ge" },
    { "id": 760, "name": "シリア・アラブ共和国", "a2": "sy" },
    { "id": 702, "name": "シンガポール", "a2": "sg" },
    { "id": 534, "name": "シント・マールテン（オランダ領）", "a2": "sx" },
    { "id": 716, "name": "ジンバブエ", "a2": "zw" },
    { "id": 756, "name": "スイス", "a2": "ch" },
    { "id": 752, "name": "スウェーデン", "a2": "se" },
    { "id": 729, "name": "スーダン", "a2": "sd" },
    { "id": 744, "name": "スヴァールバル諸島およびヤンマイエン島", "a2": "sj" },
    { "id": 724, "name": "スペイン", "a2": "es" },
    { "id": 740, "name": "スリナム", "a2": "sr" },
    { "id": 144, "name": "スリランカ", "a2": "lk" },
    { "id": 703, "name": "スロバキア", "a2": "sk" },
    { "id": 705, "name": "スロベニア", "a2": "si" },
    { "id": 690, "name": "セーシェル", "a2": "sc" },
    { "id": 226, "name": "赤道ギニア", "a2": "gq" },
    { "id": 686, "name": "セネガル", "a2": "sn" },
    { "id": 688, "name": "セルビア", "a2": "rs" },
    { "id": 659, "name": "セントクリストファー・ネイビス", "a2": "kn" },
    { "id": 670, "name": "セントビンセントおよびグレナディーン諸島", "a2": "vc" },
    { "id": 654, "name": "セントヘレナ・アセンションおよびトリスタンダクーニャ", "a2": "sh" },
    { "id": 662, "name": "セントルシア", "a2": "lc" },
    { "id": 706, "name": "ソマリア", "a2": "so" },
    { "id": 90, "name": "ソロモン諸島", "a2": "sb" },
    { "id": 796, "name": "タークス・カイコス諸島", "a2": "tc" },
    { "id": 764, "name": "タイ", "a2": "th" },
    { "id": 410, "name": "大韓民国", "a2": "kr" },
    { "id": 158, "name": "台湾", "a2": "tw" },
    { "id": 762, "name": "タジキスタン", "a2": "tj" },
    { "id": 834, "name": "タンザニア", "a2": "tz" },
    { "id": 203, "name": "チェコ", "a2": "cz" },
    { "id": 148, "name": "チャド", "a2": "td" },
    { "id": 140, "name": "中央アフリカ共和国", "a2": "cf" },
    { "id": 156, "name": "中国本土", "a2": "cn" },
    { "id": 788, "name": "チュニジア", "a2": "tn" },
    { "id": 408, "name": "朝鮮民主主義人民共和国", "a2": "kp" },
    { "id": 152, "name": "チリ", "a2": "cl" },
    { "id": 798, "name": "ツバル", "a2": "tv" },
    { "id": 208, "name": "デンマーク", "a2": "dk" },
    { "id": 276, "name": "ドイツ", "a2": "de" },
    { "id": 768, "name": "トーゴ", "a2": "tg" },
    { "id": 772, "name": "トケラウ", "a2": "tk" },
    { "id": 214, "name": "ドミニカ共和国", "a2": "do" },
    { "id": 212, "name": "ドミニカ国", "a2": "dm" },
    { "id": 780, "name": "トリニダード・トバゴ", "a2": "tt" },
    { "id": 795, "name": "トルクメニスタン", "a2": "tm" },
    { "id": 792, "name": "トルコ", "a2": "tr" },
    { "id": 776, "name": "トンガ", "a2": "to" },
    { "id": 566, "name": "ナイジェリア", "a2": "ng" },
    { "id": 520, "name": "ナウル", "a2": "nr" },
    { "id": 516, "name": "ナミビア", "a2": "na" },
    { "id": 10, "name": "南極", "a2": "aq" },
    { "id": 570, "name": "ニウエ", "a2": "nu" },
    { "id": 558, "name": "ニカラグア", "a2": "ni" },
    { "id": 562, "name": "ニジェール", "a2": "ne" },
    { "id": 392, "name": "日本", "a2": "jp" },
    { "id": 732, "name": "西サハラ", "a2": "eh" },
    { "id": 540, "name": "ニューカレドニア", "a2": "nc" },
    { "id": 554, "name": "ニュージーランド", "a2": "nz" },
    { "id": 524, "name": "ネパール", "a2": "np" },
    { "id": 574, "name": "ノーフォーク島", "a2": "nf" },
    { "id": 578, "name": "ノルウェー", "a2": "no" },
    { "id": 334, "name": "ハード島とマクドナルド諸島", "a2": "hm" },
    { "id": 48, "name": "バーレーン", "a2": "bh" },
    { "id": 332, "name": "ハイチ", "a2": "ht" },
    { "id": 586, "name": "パキスタン", "a2": "pk" },
    { "id": 336, "name": "バチカン市国", "a2": "va" },
    { "id": 591, "name": "パナマ", "a2": "pa" },
    { "id": 548, "name": "バヌアツ", "a2": "vu" },
    { "id": 44, "name": "バハマ", "a2": "bs" },
    { "id": 598, "name": "パプアニューギニア", "a2": "pg" },
    { "id": 60, "name": "バミューダ", "a2": "bm" },
    { "id": 585, "name": "パラオ", "a2": "pw" },
    { "id": 600, "name": "パラグアイ", "a2": "py" },
    { "id": 52, "name": "バルバドス", "a2": "bb" },
    { "id": 275, "name": "パレスチナ", "a2": "ps" },
    { "id": 348, "name": "ハンガリー", "a2": "hu" },
    { "id": 50, "name": "バングラデシュ", "a2": "bd" },
    { "id": 626, "name": "東ティモール", "a2": "tl" },
    { "id": 612, "name": "ピトケアン", "a2": "pn" },
    { "id": 242, "name": "フィジー", "a2": "fj" },
    { "id": 608, "name": "フィリピン", "a2": "ph" },
    { "id": 246, "name": "フィンランド", "a2": "fi" },
    { "id": 64, "name": "ブータン", "a2": "bt" },
    { "id": 74, "name": "ブーベ島", "a2": "bv" },
    { "id": 630, "name": "プエルトリコ", "a2": "pr" },
    { "id": 234, "name": "フェロー諸島", "a2": "fo" },
    { "id": 238, "name": "フォークランド（マルビナス）諸島", "a2": "fk" },
    { "id": 76, "name": "ブラジル", "a2": "br" },
    { "id": 250, "name": "フランス", "a2": "fr" },
    { "id": 254, "name": "フランス領ギアナ", "a2": "gf" },
    { "id": 258, "name": "フランス領ポリネシア", "a2": "pf" },
    { "id": 260, "name": "フランス領南方・南極地域", "a2": "tf" },
    { "id": 100, "name": "ブルガリア", "a2": "bg" },
    { "id": 854, "name": "ブルキナファソ", "a2": "bf" },
    { "id": 96, "name": "ブルネイ・ダルサラーム", "a2": "bn" },
    { "id": 108, "name": "ブルンジ", "a2": "bi" },
    { "id": 704, "name": "ベトナム", "a2": "vn" },
    { "id": 204, "name": "ベナン", "a2": "bj" },
    { "id": 862, "name": "ベネズエラ・ボリバル共和国", "a2": "ve" },
    { "id": 112, "name": "ベラルーシ", "a2": "by" },
    { "id": 84, "name": "ベリーズ", "a2": "bz" },
    { "id": 604, "name": "ペルー", "a2": "pe" },
    { "id": 56, "name": "ベルギー", "a2": "be" },
    { "id": 616, "name": "ポーランド", "a2": "pl" },
    { "id": 70, "name": "ボスニア・ヘルツェゴビナ", "a2": "ba" },
    { "id": 72, "name": "ボツワナ", "a2": "bw" },
    { "id": 535, "name": "ボネール、シント・ユースタティウスおよびサバ", "a2": "bq" },
    { "id": 68, "name": "ボリビア多民族国", "a2": "bo" },
    { "id": 620, "name": "ポルトガル", "a2": "pt" },
    { "id": 344, "name": "香港", "a2": "hk" },
    { "id": 340, "name": "ホンジュラス", "a2": "hn" },
    { "id": 584, "name": "マーシャル諸島", "a2": "mh" },
    { "id": 446, "name": "マカオ", "a2": "mo" },
    { "id": 450, "name": "マダガスカル", "a2": "mg" },
    { "id": 175, "name": "マヨット", "a2": "yt" },
    { "id": 454, "name": "マラウイ", "a2": "mw" },
    { "id": 466, "name": "マリ", "a2": "ml" },
    { "id": 470, "name": "マルタ", "a2": "mt" },
    { "id": 474, "name": "マルティニーク", "a2": "mq" },
    { "id": 458, "name": "マレーシア", "a2": "my" },
    { "id": 833, "name": "マン島", "a2": "im" },
    { "id": 583, "name": "ミクロネシア連邦", "a2": "fm" },
    { "id": 710, "name": "南アフリカ", "a2": "za" },
    { "id": 728, "name": "南スーダン", "a2": "ss" },
    { "id": 104, "name": "ミャンマー", "a2": "mm" },
    { "id": 484, "name": "メキシコ", "a2": "mx" },
    { "id": 480, "name": "モーリシャス", "a2": "mu" },
    { "id": 478, "name": "モーリタニア", "a2": "mr" },
    { "id": 508, "name": "モザンビーク", "a2": "mz" },
    { "id": 492, "name": "モナコ", "a2": "mc" },
    { "id": 462, "name": "モルディブ", "a2": "mv" },
    { "id": 498, "name": "モルドバ共和国", "a2": "md" },
    { "id": 504, "name": "モロッコ", "a2": "ma" },
    { "id": 496, "name": "モンゴル", "a2": "mn" },
    { "id": 499, "name": "モンテネグロ", "a2": "me" },
    { "id": 500, "name": "モントセラト", "a2": "ms" },
    { "id": 400, "name": "ヨルダン", "a2": "jo" },
    { "id": 418, "name": "ラオス人民民主共和国", "a2": "la" },
    { "id": 428, "name": "ラトビア", "a2": "lv" },
    { "id": 440, "name": "リトアニア", "a2": "lt" },
    { "id": 434, "name": "リビア", "a2": "ly" },
    { "id": 438, "name": "リヒテンシュタイン", "a2": "li" },
    { "id": 430, "name": "リベリア", "a2": "lr" },
    { "id": 642, "name": "ルーマニア", "a2": "ro" },
    { "id": 442, "name": "ルクセンブルク", "a2": "lu" },
    { "id": 646, "name": "ルワンダ", "a2": "rw" },
    { "id": 426, "name": "レソト", "a2": "ls" },
    { "id": 422, "name": "レバノン", "a2": "lb" },
    { "id": 638, "name": "レユニオン", "a2": "re" },
    { "id": 643, "name": "ロシア連邦", "a2": "ru" }
  ]
}
